import React from "react";
import { Typography, IconButton } from "@material-ui/core";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import EditOutlinedIcon from "@material-ui/icons/EditOutlined";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";

type CompanionSummaryCardProps = {
  fullName: string;
  documentId?: string;
  isActionsDisabled: boolean;
  onEdit: () => void;
  onDelete: () => void;
};

const CompanionSummaryCard: React.FC<CompanionSummaryCardProps> = ({
  fullName,
  documentId,
  isActionsDisabled,
  onEdit,
  onDelete,
}) => {
  return (
    <div className="vehicleCompanionSummary">
      <div className="vehicleCompanionSummaryContent">
        <AccountCircleIcon className="vehicleCompanionSummaryIcon" />
        <div className="vehicleCompanionSummaryInfo">
          <Typography className="vehicleCompanionSummaryName">{fullName}</Typography>
          {documentId && (
            <Typography className="vehicleCompanionSummaryDoc">DNI {documentId}</Typography>
          )}
        </div>
      </div>
      <div className="vehicleCompanionSummaryActions">
        <IconButton
          className="vehicleCompanionSummaryActionButton"
          onClick={onEdit}
          disabled={isActionsDisabled}
        >
          <EditOutlinedIcon />
        </IconButton>
        <IconButton
          className="vehicleCompanionSummaryActionButton"
          onClick={onDelete}
          disabled={isActionsDisabled}
        >
          <DeleteOutlineIcon style={{ color: "#ef4444" }} />
        </IconButton>
      </div>
    </div>
  );
};

export default CompanionSummaryCard;
